import { http } from 'api';

const AREA = 'profile';

const SUB_AREA = 'reset';

export const getProfileByIdApi = (profileId) =>
  http.get(AREA, {
    params: {
      'admin-id': profileId,
    },
  });

export const getProfileRolesApi = () => http.get(`${AREA}/roles`);

export const editProfileApi = ({ profileId, body }) =>
  http.put(AREA, body, {
    params: {
      'admin-id': profileId,
    },
  });

export const editProfileFacilityApi = ({ profileId, newFacilityId }) =>
  http.put(`${AREA}/facility-id`, null, {
    params: {
      'admin-id': profileId,
      'facility-id': newFacilityId,
    },
  });

export const editProfileVendorApi = ({ profileId, newVendorId }) =>
  http.put(`${AREA}/vendor-id`, null, {
    params: {
      'admin-id': profileId,
      'vendor-id': newVendorId,
    },
  });

export const editProfileRegionApi = ({ profileId, region }) =>
  http.put(`${AREA}/region`, {
    profileId,
    region,
  });

export const editProfileRoleApi = ({ profileId, newRole }) =>
  http.put(`${AREA}/role`, null, {
    params: {
      'admin-id': profileId,
      role: newRole,
    },
  });

export const editProfileChallengeApi = ({ profileId, challengeId }) =>
  http.put(`${AREA}/challenge-id`, {
    profileId,
    challengeId,
  });

export const resetSessionApi = (email) =>
  http.post(`${SUB_AREA}/reset-session`, null, {
    params: {
      email,
    },
  });

export const resetPassword = ({ sessionId, password }) =>
  http.put(`${SUB_AREA}/reset-password`, null, {
    params: {
      'session-id': sessionId,
      password,
    },
  });
